export default __webpack_public_path__ + "static/small-1-3693a4f4984d59720ad986c21e08a45b.png";